import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { claTheme } from './theme/claTheme';
import QuizPage from './pages/QuizPage';
import OutcomePage from './pages/OutcomePage';
import NotFoundPage from './pages/NotFoundPage';

export function App(): JSX.Element {
  return (
    <ThemeProvider theme={claTheme}>
      <CssBaseline />
      <Routes>
        <Route path="/" element={<Navigate to="/quiz/1" replace />} />
        <Route path="/quiz/:quizId" element={<QuizPage />} />
        <Route path="/outcome/:assessmentId" element={<OutcomePage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
